import { render, staticRenderFns } from "./ShowEventBase.vue?vue&type=template&id=a938f354&"
import script from "./ShowEventBase.vue?vue&type=script&lang=ts&"
export * from "./ShowEventBase.vue?vue&type=script&lang=ts&"
import style0 from "./ShowEventBase.vue?vue&type=style&index=0&id=a938f354&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports